import { HomeHero } from "@/components/home/HomeHero";
import { HomeServiceChooser } from "@/components/home/HomeServiceChooser";
import { HomeUniverses } from "@/components/home/HomeUniverses";
import { HomeWhy } from "@/components/home/HomeWhy";
import { HomeProofSection } from "@/components/home/HomeProofSection";
import { HomeCtaBanner } from "@/components/home/HomeCtaBanner";
import { HomeFeedsProvider } from "@/context/HomeFeedsContext";

/**
 * Slim homepage: decide → prove → orient → CTA.
 * Trust/stats band omitted until the supplier base is large enough to be social proof.
 */
export default function Home() {
  return (
    <HomeFeedsProvider limit={8}>
      <div className="bg-white">
        <HomeHero />
        <HomeServiceChooser />
        <HomeProofSection />
        <HomeUniverses />
        <HomeWhy />
        <HomeCtaBanner />
      </div>
    </HomeFeedsProvider>
  );
}
